import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  paper: {
    alignItems: 'center',
  },
  autocomplete: {
    margin: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: theme.spacing(1),
  },
  iconButtonSearch: {
    marginRight: theme.spacing(2),
    padding: theme.spacing(1),
  },
}));
